import React, { useEffect, useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const PERMISSION_OPTIONS = [
  { value: 'lectura', label: 'Lectura' },
  { value: 'lectura_escritura', label: 'Lectura y Escritura' },
  { value: 'sin_acceso', label: 'Sin acceso ' },
  { value: '', label: 'Sin permisos especiales' },
];

const EditFolderPermission = ({ hubId, selectedUserId, selectedUserName, folder, onPermissionsUpdated }) => {
  const [currentPermission, setCurrentPermission] = useState('');

  useEffect(() => {
    if (folder?.permisosUsuarios && selectedUserId) {
      setCurrentPermission(folder.permisosUsuarios[selectedUserId] || '');
    }
  }, [folder, selectedUserId]);

  const handlePermissionChange = async (e) => {
    const newPermission = e.target.value;

    try {
      const folderRef = doc(db, 'private-hubs', hubId, 'Carpetas', folder.id);
      const updatedPermisos = { ...folder.permisosUsuarios };

      if (newPermission) {
        updatedPermisos[selectedUserId] = newPermission;
      } else {
        delete updatedPermisos[selectedUserId];
      }

      await updateDoc(folderRef, {
        permisosUsuarios: updatedPermisos,
      });

      setCurrentPermission(newPermission);

      if (onPermissionsUpdated) {
        onPermissionsUpdated(); // <-- Notificar al padre
      }
      
    } catch (error) {
      console.error('Error actualizando permisos:', error);
      alert('Hubo un problema al actualizar los permisos.');
    }
  };

  if (!folder || !selectedUserId) return null;

  return (
    <div>
      <label className="labelText" style={{fontSize: '18px', color: 'black'}}>Permiso para el usuario {selectedUserName} </label>
      <select
        value={currentPermission}
        onChange={handlePermissionChange}
        className="labelText"
        style={{ padding: '6px 12px', fontSize: '1rem', marginTop: '15px' }}
      >
        {PERMISSION_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default EditFolderPermission;
